
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { generateTypeScaleSizes, DEFAULT_TYPESCALE_CONFIG } from '../utils/typography.js';
import { colors } from './colors.js';
import alert from './config/alert.js';
import badge from './config/badge.js';
import button from './config/button.js';
import breadcrumbs from './config/breadcrumbs.js';
import card from './config/card.js';
import chip from './config/chip.js';
import drawer from './config/drawer.js';
import dropdown from './config/dropdown.js';
import formElements from './config/formElements.js';
import loader from './config/loader.js';
import modal from './config/modal.js';
import progressBar from './config/progressBar.js';
import result from './config/result.js';
import sidebar from './config/sidebar.js';
import tabs from './config/tabs.js';
import table from './config/table.js';
import tag from './config/tag.js';
import tooltip from './config/tooltip.js';
import pagination from './config/pagination.js';
import scrollbar from './config/scrollbar.js';
import statusTag from './config/statusTag.js';

var typeScaleSizes = generateTypeScaleSizes(DEFAULT_TYPESCALE_CONFIG);
var defaultTheme = {
  body: {
    color: colors.black,
    background: colors.white,
    fontSize: "100%",
    lineHeight: 1.5715,
    fontFamily: "\"Mulish\", Arial, sans-serif"
  },
  link: {
    color: colors.primary.base,
    hoverColor: colors.primary.lighter
  },
  typeScaleSizes: typeScaleSizes,
  alert: alert,
  badge: badge,
  button: button,
  card: card,
  chip: chip,
  drawer: drawer,
  formElements: formElements,
  loader: loader,
  modal: modal,
  progressBar: progressBar,
  result: result,
  sidebar: sidebar,
  table: table,
  tabs: tabs,
  tag: tag,
  tooltip: tooltip,
  pagination: pagination,
  dropdown: dropdown,
  scrollbar: scrollbar,
  statusTag: statusTag,
  breadcrumbs: breadcrumbs
};

export { defaultTheme as default };
//# sourceMappingURL=defaultTheme.js.map
